import { SectionProps, TableView } from '@euler/components/TableView';
import { memo } from 'react';
import { useOrderFormStyles } from './styles';

export const Section = memo(
  ({
    titlePlacement = 'outside',
    style,
    titleStyle,
    titleTextStyle,
    ...props
  }: SectionProps) => {
    const styles = useOrderFormStyles();
    return (
      <TableView.Section
        titlePlacement={titlePlacement}
        style={[styles.section, style]}
        titleStyle={[styles.sectionTitle, titleStyle]}
        titleTextStyle={[styles.sectionTitleText, titleTextStyle]}
        {...props}
      />
    );
  },
);

Section.displayName = 'TableSection';
